const $body = $('body'),
    $container = $('#dbk-lightbox-gallery-container'),
    $galleryOverlay = $container.closest('.dbk-lightbox'),
    $close = $galleryOverlay.find('button.dbk-lightbox__close'),
    classItemActive = 'gallery__item--active',
    classItemPrev = 'gallery__item--prev',
    classItemNext = 'gallery__item--next',
    classItemLeft = 'gallery__item--left',
    classItemRight = 'gallery__item--right';

const $lightboxLoader = $('#dbk-lightbox-loader'),
    classLoaderVisible = 'dbk-lightbox-loader--visible';

// init lightbox
$('[data-toggle="dbk-lightbox"]').on('click', function() {
    const $e = $(this),
        images = $e.data('images');

    let goToSlideIndex = $e.data('slide-to');

    if (images.length > 0 && $container.length > 0) {
        // show loader
        $lightboxLoader.addClass(classLoaderVisible);

        $.ajax({
            type: 'POST',
            url: resturl + 'dbk/lightbox',
            data: {
                'images': images
            },
            dataType: 'json',
        }).done(function (response) {
            // console.log(response);

            $container.html(response);

            if (typeof goToSlideIndex === 'undefined') {
                goToSlideIndex = 1;
            }

            showGallery(goToSlideIndex);
        }).fail(function () {
            console.log('Error fetching gallery. Please try again later.');
        }).always(function () {
            $lightboxLoader.removeClass(classLoaderVisible);
        });
    }
})

$close.on('click', function () {
    hideGallery();
});

$(document).keyup(function(e) {
    // when escape key is pressed
    if (e.key === "Escape") {
        hideGallery();
    }

    let $galleryControlPrev = $('.dbk-lightbox .gallery__control--prev'),
        $galleryControlNext = $('.dbk-lightbox .gallery__control--next');

    // when left key is pressed
    if (e.which === 37) {
        if ($galleryControlPrev.length > 0) {
            $galleryControlPrev.trigger('click');
        }
    }

    // when right key is pressed
    if (e.which === 39) {
        if ($galleryControlNext.length > 0) {
            $galleryControlNext.trigger('click');
        }
    }
});

function showGallery(goToSlideIndex = false) {
    $body.addClass('dbk-lightbox-visible');
    $galleryOverlay.show();

    if (goToSlideIndex) {
        goToSlide(goToSlideIndex);
    }
}

function hideGallery() {
    $galleryOverlay.hide();
    $body.removeClass('dbk-lightbox-visible');

    // clear gallery overlay contents on close
    $container.empty();
}

function goToSlide(index = false) {
    if (!index) return false;

    let $carousel = $galleryOverlay.find('.gallery__carousel');

    $carousel.find('.gallery__item:nth-child('+ index +')').addClass(classItemActive);
}

// carousel controls
$body.on('click', '.dbk-lightbox .gallery__control', function() {
    let $control = $(this),
        $carousel = $control.siblings('.gallery__carousel'),
        $currentSlide = $carousel.find('.'+ classItemActive),
        $nextSlide,
        animationDelay = 500;

    // disable control until slide animation is complete
    $control.prop('disabled', true);
    setTimeout(function() {
        $control.prop('disabled', false);
    }, animationDelay);

    // previous slide
    if ($control.hasClass('gallery__control--prev')) {
        $nextSlide = $currentSlide.prev('.gallery__item');

        if ($nextSlide.length <= 0) {
            $nextSlide = $carousel.find('.gallery__item:last-child');
        }

        $currentSlide.addClass(classItemRight);
        $nextSlide.addClass(classItemPrev);

        setTimeout(function() {
            $nextSlide.addClass(classItemRight);
        }, 1);
    }

    // next slide
    if ($control.hasClass('gallery__control--next')) {
        $nextSlide = $currentSlide.next('.gallery__item');

        if ($nextSlide.length <= 0) {
            $nextSlide = $carousel.find('.gallery__item:first-child');
        }

        $currentSlide.addClass(classItemLeft);
        $nextSlide.addClass(classItemNext);

        setTimeout(function() {
            $nextSlide.addClass(classItemLeft);
        }, 1);
    }

    // after slide animation
    setTimeout(function() {
        $currentSlide.removeClass(classItemLeft).removeClass(classItemRight).removeClass(classItemActive);
        $nextSlide.removeClass(classItemLeft).removeClass(classItemRight).removeClass(classItemPrev).removeClass(classItemNext).addClass(classItemActive);
    }, animationDelay);
});